import React, { useState, useEffect, useRef } from "react";
import { HeaderText, Button, Toast } from "../";
import { useOrderContext, useAppContext } from "../../contexts";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setProductDetails,
  updateExchangeSettingsDetails,
  updateRefundSettingsDetails,
  updateOtherSettings,
} from "../../redux/slices";
import {
  productActionTypes,
  exchangeSettingsActionTypes,
  refundSettingsActionTypes,
  otherSettingsActionTypes,
} from "../../redux/utils";
import { capitalizeFirstLetter } from "../../Utilities/capitalizeFirstLetter";
import { useAPI, useHardCode } from "../../hooks";

export const Return = () => {
  const [isTextArea, setIsTextArea] = useState(false);
  const [reasonText, setReasonText] = useState("");
  const [otherReason, setOtherReason] = useState(false);
  const [isImgOptional, setIsImgOptional] = useState(false);
  const [changeRoute, setChangeRoute] = useState("");
  const [returnReason, setReturnReason] = useState();
  const [allowSubreason, setAllowSubreason] = useState(false);
  const [reasonID, setReasonID] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const { isInternalServerError, setIsInternalServerError } = useAppContext();
  const reasonDetailRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const settingState = useSelector((state) => state.storeSettings);
  const productDetailsState = useSelector((state) => state.productDetails);
  const selectedProductDetailsState = useSelector(
    (state) => state.selectedProductDetails
  );
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME } = useHardCode();
  const storeConfigState = useSelector((state) => state.storeSettings);
  const { setIsSelected } = useOrderContext();
  const { FETCH_INCENTIVE_API } = useAPI();

  useEffect(() => {
    setReturnReason(productDetailsState.returnReason);
  }, []);

  useEffect(() => {
    dispatch(
      updateOtherSettings({
        key: otherSettingsActionTypes.UPDATE_IS_IMG_OPTIONAL,
        value: isImgOptional,
      })
    );
  }, [isImgOptional]);

  useEffect(() => {
    if (reasonText === "collect_multiple") {
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_IS_MULTIPLE_IMAGES_UPLOAD,
          value: true,
        })
      );

      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_IS_IMAGE_UPLOAD,
          value: true,
        })
      );
    } else if (reasonText === "collect_one" || reasonText === "collect") {
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_IS_SINGLE_IMAGE_UPLOAD,
          value: true,
        })
      );

      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_IS_IMAGE_UPLOAD,
          value: true,
        })
      );
    } else if (reasonText === "" || reasonText === "dont_collect") {
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_IS_IMAGE_UPLOAD,
          value: false,
        })
      );

      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_IMAGE_LIST,
          value: null,
        })
      );

      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_IS_MULTIPLE_IMAGES_UPLOAD,
          value: false,
        })
      );

      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_IS_SINGLE_IMAGE_UPLOAD,
          value: false,
        })
      );
    }
    if(allowSubreason === true){
      setChangeRoute("/subreason");
    } else {
      setChangeRoute("/return");
    }
  }, [reasonText, dispatch]);

  const showOtherReason = (closeTextBox) => {
    if (closeTextBox) {
      reasonDetailRef.current.value = "";
      setIsTextArea(false);
    } else {
      setIsTextArea(true);
    }
  };

  const checkExchangeAndReturn = (item) => {
    const ItemExchangeAllowed = selectedProductDetailsState.itemExchangeAllowed;

    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_ALLOW_EXCHANGE,
        value: item.allow_exchange,
      })
    );

    if (ItemExchangeAllowed === false || item.allow_exchange === false) {
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_FINAL_EXCHANGE,
          value: false,
        })
      );
    } else {
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_FINAL_EXCHANGE,
          value: true,
        })
      );
    }

    const EnableIncentive = productDetailsState.enableIncentive;
    const ReturnAllowed = selectedProductDetailsState.returnAllowed;

    if (!selectedProductDetailsState.returnAllowed || !item.allow_return) {
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_IS_ENABLE_REFUND,
          value: false,
        })
      );
    } else {
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_IS_ENABLE_REFUND,
          value: true,
        })
      );
    }
    if (!EnableIncentive && (!ReturnAllowed || !item.allow_return)) {
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_FINAL_INCENTIVE,
          value: false,
        })
      );
    } else {
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_FINAL_INCENTIVE,
          value: true,
        })
      );
    }

    dispatch(
      setProductDetails({
        key: productActionTypes.SET_RETURN_REASON_ID,
        value: item.reason.id,
      })
    );
    dispatch(
      setProductDetails({
        key: productActionTypes.SET_RETURN_REASON_DESC,
        value: item,
      })
    );

    if(item?.allow_subreasons === true){
      setAllowSubreason(true);
    } else {
      setAllowSubreason(false);
    }
  };

  const buttonHandler = () => {
    (async () => {
      try {
        setIsLoader(true);
        setIsBtnDisabled(true);
        const VariantID = selectedProductDetailsState.variantID;
        const response = await fetch(FETCH_INCENTIVE_API, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            shop_data: settingState.storeUniqueID,
            variants: VariantID,
            quantity: parseInt(selectedProductDetailsState.selectedQuantity),
            order_number: productDetailsState.orderNumber,
            ordid: productDetailsState.recentOrderID,
            return_reason_id: productDetailsState.returnReasonID,
            customer_id: productDetailsState.customerID,
            payment_method: productDetailsState.paymentMethod,
            customer_phone: productDetailsState.customerContact,
            customer_email: productDetailsState.customerEmail,
            line_item_id: selectedProductDetailsState.lineItemID,
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (response.ok) {
          dispatch(
            setProductDetails({
              key: productActionTypes.SET_REASON_DETAILS,
              value: reasonDetailRef.current.value,
            })
          );

          dispatch(
            updateRefundSettingsDetails({
              key: refundSettingsActionTypes.UPDATE_INCENTIVE,
              value: data?.data?.incentive,
            })
          );
          dispatch(
            updateRefundSettingsDetails({
              key: refundSettingsActionTypes.UPDATE_INCENTIVE_MESSAGE,
              value: data?.message,
            })
          );
          dispatch(
            updateRefundSettingsDetails({
              key: refundSettingsActionTypes.UPDATE_INCENTIVE_STATUS,
              value: data?.status,
            })
          );

          setReasonID(null);
          setIsBtnDisabled(false);
          navigate(changeRoute);
        }
      } catch (error) {
        console.log(error);
        if (error.message.includes('500')) {
          setIsInternalServerError(true);
        }
        setIsBtnDisabled(false);
      }
    })();
  };

  const backHandler = () => {
    window.history.back();
  };

  const isReasonDetailEmpty = () => {
    if (reasonDetailRef?.current?.value?.length > 0 && otherReason) {
      setIsBtnDisabled(false);
    } else if (reasonID && otherReason === false) {
      setIsBtnDisabled(false);
    } else {
      setIsBtnDisabled(true);
    }
  };

  const reasonHandler = (reasonName) => {
    if (
      reasonName === "other reason" ||
      reasonName === "other reasons" ||
      reasonName === "other" ||
      reasonName === "others"
    ) {
      setOtherReason(true);
      setIsTextArea(true);
      if (reasonDetailRef?.current?.value?.length > 0) {
        setIsBtnDisabled(false);
      } else {
        setIsBtnDisabled(true);
      }
    } else if (reasonName) {
      setOtherReason(false);
      setIsBtnDisabled(false);
    } else {
      setOtherReason(false);
      setIsBtnDisabled(true);
    }
  };
  return (
    <div className="saara-item-reason-container">
      {isInternalServerError && <Toast type="error" />}
      <div className="saara-item-heading">
        <div>
          <Link to="" onClick={backHandler} className="backIcon">
            <img src="assets/svg/chevron_left.svg" width="24" alt="back" />
          </Link>
        </div>

        <HeaderText
          text={storeConfigState?.themeConfig?.reason_selection_page_title}
        />
      </div>
      <div className="reason-main-container">
        {returnReason?.map((item) => (
          <div
            key={item.reason.id}
            className={`reason_item ${reasonID === item.reason.id && "active"}`}
            onClick={() => {
              setIsSelected(true);
              setReasonID(item.reason.id);
              checkExchangeAndReturn(item);
              reasonHandler(item.reason.name.toLowerCase());
              setReasonText(item.picture_collection);
              setIsImgOptional(item.is_optional);
            }}
          >
            <span>{capitalizeFirstLetter(item.reason.name)}</span>
            <input
              className="return_option_radio radio_option"
              name="return_radio"
              type="radio"
              checked={reasonID === item.reason.id}
            />
          </div>
        ))}
        <div className={`reason_details`}>
          <label
            className={`${
              isTextArea
                ? "reason_item reason_other"
                : "reason_item  reason_details_info_text_height"
            }`}
            onClick={(e) => {
              showOtherReason();
            }}
          >
            {storeConfigState?.themeConfig?.reason_description_label}

            {!SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female && (
              <span
                className={`${
                  isTextArea ? "hide" : "reason_details_info_text"
                }`}
              >
                <br /> <br /> Write about additional reason details here
              </span>
            )}
            {/* Close Icon */}
            <img
              src="assets/svg/close.svg"
              alt="close"
              onClick={(e) => {
                showOtherReason(true);
                e.preventDefault();
                e.stopPropagation();
                isReasonDetailEmpty();
              }}
              className={`${isTextArea ? "other__close show" : "other__close"}`}
            />
            {/* Text Area */}
            <textarea
              ref={reasonDetailRef}
              maxLength="500"
              className={` ${
                isTextArea ? "other__textarea show" : "other__textarea"
              }`}
              onKeyUp={(e) => {
                isReasonDetailEmpty();
              }}
              onClick={(e) => {
                setIsSelected(e.target.value.length > 0);
              }}
            ></textarea>
          </label>
        </div>
      </div>

      <div className="btns">
        <div className=" btn__big_screen margin-right-20">
          <button
            className="saara_custom_btn saara__btn btn__back back-page"
            onClick={backHandler}
          >
            {storeConfigState?.themeConfig?.back_button_label}
          </button>
        </div>
        <div>
          <Button
            name={
              isLoader ? (
                <div
                  className="saara-spinner-border saara-spinner-border-sm"
                  role="status"
                >
                  <span className="visually-hidden"></span>
                </div>
              ) : (
                storeConfigState?.themeConfig?.continue_button_label
              )
            }
            onClick={buttonHandler}
            disabled={isBtnDisabled}
          />
        </div>
      </div>
    </div>
  );
};
